// components/ui/PageEnter.tsx
'use client';

import React, { useLayoutEffect, useRef } from 'react';

const FRAMES: Keyframe[] = [
  { opacity: 0, transform: 'translateY(6px)' },
  { opacity: 1, transform: 'none' },
];

// ONE ENTRANCE FOR EVERY PAGE (owner, 2026-09-30: 'each page in the app should open smoothly').
// It replays when `pageKey` changes instead of remounting, so a page keeps its state and its
// requests; and the transform ends at `none`, so a position:fixed menu inside is never trapped by
// a transformed ancestor once the 260ms are over.
export const PageEnter = ({ pageKey, className, children }: { pageKey: string; className?: string; children: React.ReactNode }) => {
  const ref = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || typeof el.animate !== 'function' || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
    const animation = el.animate(FRAMES, { duration: 260, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' });
    return () => animation.cancel();
  }, [pageKey]);
  return <div ref={ref} className={className}>{children}</div>;
};
